import React from 'react';
import { Image, View } from 'react-native-web';
import { Text } from 'react-native';
import {
  Android,
  Fingerprint_not_recognized,
  Touch_fingerprint_sensor,
} from '../../../../utils/DictionaryManagementUtils';
import FullPageSimulator from '../FullPageSimulator';
import { getRegularFont, LocStr } from '../../../../utils/Utils';

//= ========================================================================
const ClearPageWithCenterIconFP = ({
  globJSON,
  simPlatform,
  notSkipped,
  language,
  imageInsidePage,
  TopTitle,
  tintColor,
  txtMessage,
  slideshowRefs,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { auth } = globJSON.configurations.launch;

  const myStyles = {
    container: {
      paddingVertical: '25%',
    },
    imageStyle: {
      alignSelf: 'center',
      width: 42,
      height: 42,
      tintColor: tintColor || colors.primary_font_color,
    },
    labelStyle: {
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
      fontSize: 10,
      marginTop: 5,
      textAlign: 'center',
      color: txtMessage ? colors.negative_color : colors.secondary_font_color,
    },
    opacityStyle: {
      width: 240,
      height: simPlatform === Android ? 427 : 520,
      marginTop: 30,
      marginLeft: 0,
      position: 'absolute',
      backgroundColor: '#fff',
      opacity: 0.5,
    },
  };

  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      headlineText={auth.face_id_to_approve}
      TopTitle={TopTitle}
      slideshowRefs={slideshowRefs}
    >
      <View style={myStyles.container}>
        <Image
          fadeDuration={0}
          style={myStyles.imageStyle}
          source={imageInsidePage}
        />
        {simPlatform === Android && (
        <Text style={myStyles.labelStyle}>
          {LocStr(txtMessage ? Fingerprint_not_recognized : Touch_fingerprint_sensor, language)}
        </Text>
        )}
      </View>
      {!notSkipped && <View style={myStyles.opacityStyle} />}
    </FullPageSimulator>

  );
};
export default ClearPageWithCenterIconFP;
